import { render } from "./DemandUpdateModal.vue?vue&type=template&id=51ab7704&scoped=true"
import script from "./DemandUpdateModal.vue?vue&type=script&lang=js"
export * from "./DemandUpdateModal.vue?vue&type=script&lang=js"

import "./DemandUpdateModal.vue?vue&type=style&index=0&id=51ab7704&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ab7704"]])

export default __exports__